"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIComponent = require("../UIComponent.js");
var GuestcardPanel = function (_UIComponent) {
  _inherits(GuestcardPanel, _UIComponent);

  function GuestcardPanel(a, s) {
    var _this;

    _classCallCheck(this, GuestcardPanel);

    (_this = _possibleConstructorReturn(this, (GuestcardPanel.__proto__ || Object.getPrototypeOf(GuestcardPanel)).call(this, a, s)), _this), _this.callbacks = null;return _this;
  }

  _createClass(GuestcardPanel, [{
    key: "registerCallbacks",
    value: function registerCallbacks(a) {
      this.callbacks = a;
    }
  }, {
    key: "close",
    value: function close() {
      this.callbacks && this.callbacks.close && this.callbacks.close();
    }
  }, {
    key: "saveGuestCard",
    value: function saveGuestCard(a) {
      this.callbacks && this.callbacks.saveGuestCard && this.callbacks.saveGuestCard(a);
    }
  }, {
    key: "relaodGuestCard",
    value: function relaodGuestCard() {
      this.callbacks && this.callbacks.relaodGuestCard && this.callbacks.relaodGuestCard();
    }
  }, {
    key: "reloadActions",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = this.callbacks && this.callbacks.reloadActions;

                if (!_context.t0) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return this.callbacks.reloadActions();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function reloadActions() {
        return _ref.apply(this, arguments);
      }

      return reloadActions;
    }()
  }, {
    key: "validateData",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(a) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = !this.callbacks || !this.callbacks.validateData;

                if (_context2.t0) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return this.callbacks.validateData(a);

              case 4:
                _context2.t0 = _context2.sent;

              case 5:
                return _context2.abrupt("return", _context2.t0);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function validateData(_x) {
        return _ref2.apply(this, arguments);
      }

      return validateData;
    }()
  }]);

  return GuestcardPanel;
}(UIComponent);

module.exports = GuestcardPanel;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkd1ZXN0Y2FyZFBhbmVsLmpzIl0sIm5hbWVzIjpbIlVJQ29tcG9uZW50IiwicmVxdWlyZSIsIkd1ZXN0Y2FyZFBhbmVsIiwiW29iamVjdCBPYmplY3RdIiwidGVtcGxhdGUiLCJiaW5kIiwic3VwZXIiLCJ0aGlzIiwiY2FsbGJhY2tzIiwiY2xvc2UiLCJjYWxsYmFjayIsInNhdmVHdWVzdENhcmQiLCJyZWxhb2RHdWVzdENhcmQiLCJyZWxvYWRBY3Rpb25zIiwidW5zYXZlZENoYW5nZXMiLCJ2YWxpZGF0ZURhdGEiLCJtb2R1bGUiLCJleHBvcnRzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSxJQUFNQSxjQUFjQyxRQUFRLG1CQUFSQSxDQUFwQjtJQUVNQyxjOzs7QUFDRkMsMEJBQVlDLENBQVpELEVBQXNCRSxDQUF0QkYsRUFBc0JFO0FBQUFBOztBQUFBQTs7QUFDbEJDLDZIQUFNRixDQUFORSxFQUFnQkQsQ0FBaEJDLFlBRUFDLE1BQUtDLFNBQUxELEdBQWlCLElBRmpCRCxDQURrQkQ7QUFNdEJGOzs7O3NDQUFrQkssQyxFQUFBQTtBQUNkRCxXQUFLQyxTQUFMRCxHQUFpQkMsQ0FBakJEO0FBR0pKOzs7NEJBQUFBO0FBQ09JLFdBQUtDLFNBQUxELElBQWtCQSxLQUFLQyxTQUFMRCxDQUFlRSxLQUFqQ0YsSUFDQ0EsS0FBS0MsU0FBTEQsQ0FBZUUsS0FBZkYsRUFEREE7QUFLUEo7OztrQ0FBY08sQyxFQUFBQTtBQUNQSCxXQUFLQyxTQUFMRCxJQUFrQkEsS0FBS0MsU0FBTEQsQ0FBZUksYUFBakNKLElBQ0NBLEtBQUtDLFNBQUxELENBQWVJLGFBQWZKLENBQTZCRyxDQUE3QkgsQ0FEREE7QUFLUEo7OztzQ0FBQUE7QUFDT0ksV0FBS0MsU0FBTEQsSUFBa0JBLEtBQUtDLFNBQUxELENBQWVLLGVBQWpDTCxJQUNDQSxLQUFLQyxTQUFMRCxDQUFlSyxlQUFmTCxFQUREQTtBQUtQSjs7Ozs7Ozs7OzhCQUNPSSxLQUFLQyxTQUFMRCxJQUFrQkEsS0FBS0MsU0FBTEQsQ0FBZU0sYTs7Ozs7Ozs7dUJBQzFCTixLQUFLQyxTQUFMRCxDQUFlTSxhQUFmTixFOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OzRGQUlLTyxDOzs7OzsrQkFDZixDQUFHUCxLQUFLQyxTQUFSLElBQVFBLENBQWFELEtBQUtDLFNBQUxELENBQWVRLFk7Ozs7Ozs7O3VCQUNuQlIsS0FBS0MsU0FBTEQsQ0FBZVEsWUFBZlIsQ0FBNEJPLENBQTVCUCxDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0VBckNJUCxXOztBQTRDN0JnQixPQUFPQyxPQUFQRCxHQUFpQmQsY0FBakJjIn0=